import { Component } from '@theme/component';

class TextOverCard extends Component {
  handleOpen(event) {
    event.preventDefault();
    this.refs.overlay.hidden = false;
  }

  handleClose(event) {
    event.preventDefault();
    this.refs.overlay.hidden = true;
  }
}

if (!customElements.get('text-over-card')) {
  customElements.define('text-over-card', TextOverCard);
}
